import React from 'react';
import { CalendarIcon16Light } from "../../../internal/icons2022/CalendarIcon/CalendarIcon16Light";
import { CalendarIcon20Light } from "../../../internal/icons2022/CalendarIcon/CalendarIcon20Light";
import { CalendarIcon24Regular } from "../../../internal/icons2022/CalendarIcon/CalendarIcon24Regular";
import { iconSizer } from "../../../internal/icons2022/iconSizer";
export var CalendarIcon = iconSizer({
  small: function small() {
    return /*#__PURE__*/React.createElement(CalendarIcon16Light, null);
  },
  medium: function medium() {
    return /*#__PURE__*/React.createElement(CalendarIcon20Light, null);
  },
  large: function large() {
    return /*#__PURE__*/React.createElement(CalendarIcon24Regular, null);
  }
}, 'CalendarIcon');